import Vue    from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// components
import Main           from '../components/Main'
// import Login          from '../components/Login'
import ForgotPassword from '../components/ForgotPassword'
import ResetPassword  from '../components/ResetPassword'
import NotFound       from '../components/NotFound'

// Cms
import Cms                  from '../components/Cms'
import Dashboard            from '../components/cms/DashBoard'
import Profile              from '../components/cms/Profile'
import Jobs                 from '../components/cms/superuser/Jobs'
import Contacts             from '../components/cms/superuser/Contacts'
import CraftsmenDashboard   from '../components/cms/craftsmen/CraftsmenDashboard'
import Projects             from '../components/cms/superuser/projects/Projects'
import Companies            from '../components/cms/superuser/Companies'
import Reporting            from '../components/cms/superuser/Reporting'
import Messaging            from '../components/cms/superuser/Messaging'
import LockMonths           from '../components/cms/superuser/projects/LockMonths'
import TaskHistory          from '../components/cms/superuser/projects/TaskHistory'
import ApplicationSettings  from '../components/cms/superuser/ApplicationSettings'
import AddEditProject       from '../components/cms/superuser/projects/AddEditProject'
import EditSheet            from '../components/cms/craftsmen/EditSheet'
import CostTable            from '../components/cms/craftsmen/CostsTable'
import SheetSummary         from '../components/cms/craftsmen/Summary'
import TotalInvoiced        from '../components/cms/superuser/TotalInvoiced'
import Documents            from '../components/cms/superuser/Documents'
import Tasks                from '../components/cms/Tasks'


import { authMixin } from '../mixins/authMixin'

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main
    },
    // {
    //   path: '/login',
    //   name: 'Login',
    //   component: Login
    // },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword
    },
    {
      path: '/reset-password/:token',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/cms',
      name: 'Cms',
      component: Cms,
      beforeEnter: (to, from, next) => {
        if (authMixin.computed.computedLoggedIn()) {
          next()
        } else {
          next({path: '/'})
        }
      },
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          props: true
        },
        {
          path: 'craftsmenDashboard',
          name: 'CraftsmenDashboard',
          component: CraftsmenDashboard,
        },
        {
          path: 'profile',
          name: 'Profile',
          component: Profile
        },
        {
          path: 'tasks',
          name: 'Tasks',
          component: Tasks
        },
        {
          path: 'jobs',
          name: 'Jobs',
          component: Jobs
        },
        {
          path: 'contacts',
          name: 'Contacts',
          component: Contacts
        },
        {
          path: 'projects',
          name: 'Projects',
          component: Projects
        },
        {
          path: 'reporting',
          name: 'Reporting',
          component: Reporting
        },
        {
          path: 'messaging',
          name: 'Messaging',
          component: Messaging
        },
        {
          path: 'companies',
          name: 'Companies',
          component: Companies
        },
        {
          path: 'applicationSettings',
          name: 'ApplicationSettings',
          component: ApplicationSettings
        },
        {
          path: 'add-project',
          name: 'AddProject',
          component: AddEditProject
        },
        {
          path: 'edit-project/:id',
          name: 'EditProject',
          component: AddEditProject
        },
        {
          path: 'lock-months',
          name: 'LockMonths',
          component: LockMonths
        },
        {
          path: 'task-history',
          name: 'TaskHistory',
          component: TaskHistory
        },
        {
          path: 'edit-sheet/',
          name: 'EditSheet',
          component: EditSheet,
          props: true,
          children: [
            {
              path: 'actual-personnel/:id-:type-:heading',
              name: 'ActualCostsWork',
              component: CostTable,
            },
            {
              path: 'actual-material/:id-:type-:heading',
              name: 'ActualMaterialCost',
              component: CostTable
            },
            {
              path: 'actual-foreign-power/:id-:type-:heading',
              name: 'ActualForeignPower',
              component: CostTable
            },
            {
              path: 'actual-inventory/:id-:type-:heading',
              name: 'ActualInventory',
              component: CostTable
            },
            {
              path: 'actual-additional-costs/:id-:type-:heading',
              name: 'ActualAdditionalCosts',
              component: CostTable
            },
            {
              path: 'budget-personnel/:id-:type-:heading',
              name: 'BudgetCostsWork',
              component: CostTable
            },
            {
              path: 'budget-material/:id-:type-:heading',
              name: 'BudgetMaterialCost',
              component: CostTable
            },
            {
              path: 'budget-foreign-power/:id-:type-:heading',
              name: 'BudgetForeignPower',
              component: CostTable
            },
            {
              path: 'budget-inventory/:id-:type-:heading',
              name: 'BudgetInventory',
              component: CostTable
            },
            {
              path: 'budget-additional-costs/:id-:type-:heading',
              name: 'BudgetAdditionalCosts',
              component: CostTable
            },
            {
              path: 'sheet-summary/:id',
              name: 'SheetSummary',
              component: SheetSummary
            },
            {
              path: 'total-invoiced/:id',
              name: 'TotalInvoiced',
              component: TotalInvoiced
            },
            {
              path: 'documents/:id',
              name: 'Documents',
              component: Documents
            }
          ]
        }
      ]
    },
    {
      path: '/page-not-found',
      component: NotFound,
      name: 'NotFound'
    },
    {
      path: '*',
      redirect: '/page-not-found'
    }
  ]
})